export const ASSIGNMENT_DETAILS_SIDEBAR_TEXT = {
	arrival: 'Arrival',
	close: 'Close',
	collapse: 'Collapse',
	current: 'current',
	errorMsg: 'Something went wrong',
	expand: 'Expand',
	assignedCrewMember: 'Assigned Crew Member:',
	job: 'Job:',
	line: 'Line:',
	multiRideWorkAssignment: 'Multi-ride work assignment',
	noCrewMemberAssigned: 'No crew member assigned',
	opensInNewTab: 'Opens in a new tab',
	ride: 'Ride',
	rideDetails: 'Ride details',
	route: 'Route:',
	run: 'Run:',
	tripNumber: 'Trip number:',
	uuid: 'UUID:',
	departure: 'Departure',
	waDetails: 'Work Assignment Details',
	operationalStop: 'Operational stop',
};

export const getRideLabel = (rideNumber, isCurrent = false) => {
	const currentLabel = isCurrent ? ` (${ASSIGNMENT_DETAILS_SIDEBAR_TEXT.current})` : '';

	return `${ASSIGNMENT_DETAILS_SIDEBAR_TEXT.ride} ${rideNumber}${currentLabel}`;
};

export const getRideToggleLabel = (isCollapsed, rideNumber) => {
	const action = isCollapsed
		? ASSIGNMENT_DETAILS_SIDEBAR_TEXT.expand
		: ASSIGNMENT_DETAILS_SIDEBAR_TEXT.collapse;

	return `${action} ${ASSIGNMENT_DETAILS_SIDEBAR_TEXT.ride} ${rideNumber}`;
};
